import { render } from "./BillingHistory.vue?vue&type=template&id=2be734b0"
import script from "./BillingHistory.vue?vue&type=script&lang=js"
export * from "./BillingHistory.vue?vue&type=script&lang=js"

import "./BillingHistory.vue?vue&type=style&index=0&id=2be734b0&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__